import { QUESTION_TYPES } from '../constants/assignments';

export const isMCQ = (item) =>
  item.type &&
  (item.type === 'MultipleChoiceQuestion' ||
    item.type === QUESTION_TYPES.multipleChoice);

export const isFRQ = (item) =>
  item.type &&
  (item.type === 'FreeResponseQuestion' ||
    item.type === QUESTION_TYPES.freeResponse);
